import { VisioService } from '@agent/core/channel-digit/visio/visio.service';
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'cng-visio-subscriber',
  templateUrl: 'visio-subscriber.component.html',
  styleUrls: ['./visio-subscriber.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisioSubscriberComponent implements OnInit, OnDestroy {
  @ViewChild('visioSubscriberContainer', { static: true }) visioSubscriberContainer: ElementRef;
  @Input() stream: OT.Stream;
  @Output() select: EventEmitter<OT.Stream> = new EventEmitter<OT.Stream>();

  subscriber: OT.Subscriber | undefined = undefined;
  screenSharingInProcess$: Observable<OT.Stream | undefined> = this.visioService.screenSharingInProcess$;

  constructor(private readonly visioService: VisioService) {}

  ngOnInit(): void {
    if (!this.stream || !this.visioSubscriberContainer) {
      return;
    }
    this.subscriber = this.visioService.subscribe(this.stream, this.visioSubscriberContainer);
  }

  ngOnDestroy(): void {
    if (!this.subscriber) {
      return;
    }
    this.visioService.unsubscribe(this.subscriber);
  }

  getUsername(stringEntry): string {
    if (!stringEntry) {
      return '';
    }
    let data = JSON.parse(stringEntry.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": '));
    let username = data.username;
    return username;
  }

  switchFullscreen() {
    this.select.emit(this.stream);
  }
}
